/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import * as openEnums from "../../types/enums.js";
import { OpenEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * The reported skill feedback outcome.
 */
export const SkillFeedbackOutcome = {
  Helped: "helped",
  PartiallyHelped: "partially_helped",
  DidNotHelp: "did_not_help",
  Misleading: "misleading",
  Harmful: "harmful",
} as const;
/**
 * The reported skill feedback outcome.
 */
export type SkillFeedbackOutcome = OpenEnum<typeof SkillFeedbackOutcome>;

/**
 * A privacy-minimized feedback row for a skill.
 */
export type SkillFeedback = {
  /**
   * When the feedback was recorded.
   */
  createdAt: Date;
  /**
   * The feedback ID.
   */
  id: string;
  /**
   * An optional feedback note.
   */
  note?: string | undefined;
  /**
   * The reported skill feedback outcome.
   */
  outcome: SkillFeedbackOutcome;
  /**
   * When automated suggestion analysis reviewed this feedback.
   */
  reviewedAt?: Date | undefined;
  /**
   * The attributed skill version, when known.
   */
  skillVersionId?: string | undefined;
  /**
   * Where skill feedback was recorded.
   */
  source: string;
};

/** @internal */
export const SkillFeedbackOutcome$inboundSchema: z.ZodMiniType<
  SkillFeedbackOutcome,
  unknown
> = openEnums.inboundSchema(SkillFeedbackOutcome);

/** @internal */
export const SkillFeedback$inboundSchema: z.ZodMiniType<
  SkillFeedback,
  unknown
> = z.pipe(
  z.object({
    created_at: z.pipe(
      z.iso.datetime({ offset: true }),
      z.transform(v => new Date(v)),
    ),
    id: z.string(),
    note: z.optional(z.string()),
    outcome: SkillFeedbackOutcome$inboundSchema,
    reviewed_at: z.optional(
      z.pipe(z.iso.datetime({ offset: true }), z.transform(v => new Date(v))),
    ),
    skill_version_id: z.optional(z.string()),
    source: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      "created_at": "createdAt",
      "reviewed_at": "reviewedAt",
      "skill_version_id": "skillVersionId",
    });
  }),
);

export function skillFeedbackFromJSON(
  jsonString: string,
): SafeParseResult<SkillFeedback, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => SkillFeedback$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'SkillFeedback' from JSON`,
  );
}
